import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback } from 'react';

/**
 * Custom hook to handle reCAPTCHA token generation
 * @param {string} action - The action name for the captcha (e.g., 'submit_lead_form')
 * @returns {Function} - Function to execute and get captcha token
 */
export const useCaptcha = (action = 'submit') => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getCaptchaToken = useCallback(async () => {
    if (!executeRecaptcha) {
      console.warn('Execute recaptcha not yet available');
      return null;
    }

    try {
      const token = await executeRecaptcha(action);
      return token;
    } catch (error) {
      console.error('Error executing reCAPTCHA:', error);
      return null;
    }
  }, [executeRecaptcha, action]);

  return getCaptchaToken;
};

